import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, DownloadIcon, HeartHandshakeIcon, ArmchairIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { images, price } from '../data/content';
const guarantees = [{
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: HeartHandshakeIcon,
  label: 'Sin necesidad de experiencia'
}, {
  icon: ArmchairIcon,
  label: 'Solo una silla'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-56" data-mp="127ect9b6vhbc">
      <div className="pointer-events-none absolute -right-40 -top-40 h-[28rem] w-[28rem] rounded-full bg-sage-light/60 blur-3xl" aria-hidden="true" data-id="element-57" data-mp="xbpaiy7sbmbc" />
      <div className="relative mx-auto grid max-w-6xl gap-12 px-5 pb-16 pt-10 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-16 lg:pb-24 lg:pt-16" data-id="element-58" data-mp="ncq47mahs2ri">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-59" data-mp="3cz5u28857tyr">
          <span className="inline-flex items-center gap-2 rounded-full border border-clay/30 bg-clay-light px-4 py-2 text-sm font-bold uppercase tracking-[0.14em] text-clay-dark" data-id="element-60" data-mp="3j923fiwkdgsw">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="399bbnoze1fwi" />
            Libro Digital + 3 Bonos de Regalo
          </span>

          <h1 className="mt-6 font-display text-4xl font-medium leading-[1.08] text-ink sm:text-5xl lg:text-6xl" data-id="element-62" data-mp="3e7l802wummjp">
            Vientre Ligero 60+
            <span className="mt-2 block text-sage-dark" data-id="element-63" data-mp="3599jq7jgg0uf">Yoga y Tai Chi en Silla</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-64" data-mp="2qkdai75nwhs8">
            El programa suave y efectivo para reducir la panza, ganar energía y volverte a
            sentir liviana — sin experiencia previa, sin esfuerzo extremo, desde la
            comodidad de tu silla.
          </p>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6" data-id="element-65" data-mp="2ll0ht5s40ghq">
            <CtaButton data-id="element-66" data-mp="s3351dk4moxj">Quiero mi copia ahora</CtaButton>
            <p className="text-base text-muted" data-id="element-67" data-mp="s3undmopqq5v">
              <span className="font-display text-3xl font-semibold text-ink" data-id="element-68" data-mp="najg5kfzo7df">
                {price.amount}
                <span className="align-top text-xl" data-id="element-69" data-mp="icrp0sn64paa">{price.currency}</span>
              </span>
              <span className="ml-2 block sm:inline" data-id="element-70" data-mp="degcub9ei2ow">pago único</span>
            </p>
          </div>

          <ul className="mt-8 flex flex-col gap-3 text-base text-muted sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6" data-id="element-71" data-mp="1azkqxecanulv">
            {guarantees.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2" data-id="element-72" data-mp="111oln361ftvo">
                <Icon className="h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-73" data-mp="x1ee3m2lkvep" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-74" data-mp="3lqui5yd6ip9t">
          <div className="overflow-hidden rounded-4xl border border-linen bg-sand shadow-xl shadow-ink/10" data-id="element-75" data-mp="21amvn8ncdqlt">
            <img src={images.hero} alt="Mujer mayor de 60 años haciendo un ejercicio suave de yoga sentada en una silla en su casa" className="h-full w-full object-cover" loading="eager" data-id="element-76" data-mp="269hc43xu732r" />
          </div>
          <div className="absolute -bottom-6 left-4 rounded-2xl border border-linen bg-cream px-5 py-4 shadow-lg shadow-ink/10 sm:left-8" data-id="element-77" data-mp="2g25c17k45n5p">
            <p className="font-display text-2xl font-semibold text-sage-dark" data-id="element-78" data-mp="2p08rbm4i9np2">15 min</p>
            <p className="text-sm text-muted" data-id="element-79" data-mp="2u03ilqs70fan">por día, sentada</p>
          </div>
        </motion.div>
      </div>
    </header>;
}